import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, ToastType } from '../../../core/services/toast.service';

/**
 * Root-level overlay that renders all active toast notifications sourced from ToastService.
 *
 * Positioned at the bottom-right corner of the viewport via Bootstrap utility classes.
 * Each toast auto-hides after its configured delay; the `(hidden)` event triggers removal
 * from the service's signal so the DOM stays in sync.
 *
 * Rendered once in the root App component — exactly one container exists in the DOM.
 */
@Component({
  selector: 'app-toast-container',
  imports: [NgbToast],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);

  /**
   * Maps a toast severity type to Bootstrap contextual background class strings.
   * @param type The toast severity.
   * @returns Space-separated Bootstrap class string.
   */
  protected toastClass(type: ToastType): string {
    switch (type) {
      case 'success': return 'bg-success text-white';
      case 'info':    return 'bg-info text-dark';
      default:        return 'bg-danger text-white';
    }
  }
}
